import chroma from 'chroma-js';
import { cbsColors } from '../cbsGraph.config';

export const chartColors = [
	{
		color: cbsColors.blue,
		colorDarker: chroma(cbsColors.blue).darken().hex(),
		colorId: 'gradient-positive-blue',
		symbol: 'circle',
	},
	{
		color: cbsColors.violet,
		colorDarker: chroma(cbsColors.violet).darken().hex(),
		colorId: 'gradient-violet',
		symbol: 'diamond',
	},
	{
		color: cbsColors.green,
		colorDarker: chroma(cbsColors.green).darken().hex(),
		colorId: 'gradient-mosgroen',
		symbol: 'square',
	},
] as const satisfies Array<{
	color: string;
	colorDarker: string;
	colorId: string;
	symbol: 'circle' | 'diamond' | 'square';
}>;
